module.exports = __webpack_public_path__ + "static/media/credencial.8f198ab7.svg";